/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_You_Are_A_Luxury_ConcierInputs */

const en_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 'You are a luxury concierge. Be very exclusive, mention the rare materials, and prioritize viewing appointments.'`)
};

const es_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. 'Eres un conserje de lujo. Sé muy exclusivo, menciona los materiales raros y da prioridad a las citas de visualización.'`)
};

const fr_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 'Vous êtes un concierge de luxe. Soyez très exclusif, mentionnez les matériaux rares et donnez la priorité aux rendez-vous de visite.'`)
};

const de_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 'Du bist ein Luxus-Concierge. Sei sehr exklusiv, erwähne die seltenen Materialien und priorisiere Besichtigungstermine.'`)
};

const ja_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 'あなたはラグジュアリーコンシェルジュです。非常に排他的に振る舞い、希少な素材について言及し、内覧の予約を優先してください。'`)
};

const zh_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：'您是一位奢侈品礼宾。请保持极高的独家感，提及稀有材质，并优先安排看货预约。'`)
};

const ar_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: 'أنت مساعد ذكي فاخر. كن حصرياً للغاية، واذكر المواد النادرة، وأعط الأولوية لمواعيد المشاهدة.'`)
};

const id_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. 'Anda adalah seorang pramutamu mewah. Bersikaplah sangat eksklusif, sebutkan material yang langka, dan prioritaskan jadwal penayangan.'`)
};

const it_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. 'Sei un concierge di lusso. Sii molto esclusivo, menziona i materiali rari e dai priorità agli appuntamenti per le visite.'`)
};

const ru_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, 'Вы — роскошный консьерж. Будьте очень эксклюзивны, упоминайте редкие материалы и отдавайте приоритет назначениям на осмотр.'`)
};

const pt_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 'Você é um concierge de luxo. Seja muito exclusivo, mencione os materiais raros e priorize visitas com hora marcada.'`)
};

const ko_eg_you_are_a_luxury_concier = /** @type {(inputs: Eg_You_Are_A_Luxury_ConcierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: '당신은 럭셔리 컨시어지입니다. 매우 독점적인 느낌을 주고, 희귀한 소재를 언급하며, 방문 예약을 우선시하세요.'`)
};

/**
* | output |
* | --- |
* | "e.g. 'You are a luxury concierge. Be very exclusive, mention the rare materials, and prioritize viewing appointments.'" |
*
* @param {Eg_You_Are_A_Luxury_ConcierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_you_are_a_luxury_concier = /** @type {((inputs?: Eg_You_Are_A_Luxury_ConcierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_You_Are_A_Luxury_ConcierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_you_are_a_luxury_concier(inputs)
	if (locale === "es") return es_eg_you_are_a_luxury_concier(inputs)
	if (locale === "fr") return fr_eg_you_are_a_luxury_concier(inputs)
	if (locale === "de") return de_eg_you_are_a_luxury_concier(inputs)
	if (locale === "ja") return ja_eg_you_are_a_luxury_concier(inputs)
	if (locale === "zh") return zh_eg_you_are_a_luxury_concier(inputs)
	if (locale === "ar") return ar_eg_you_are_a_luxury_concier(inputs)
	if (locale === "id") return id_eg_you_are_a_luxury_concier(inputs)
	if (locale === "it") return it_eg_you_are_a_luxury_concier(inputs)
	if (locale === "ru") return ru_eg_you_are_a_luxury_concier(inputs)
	if (locale === "pt") return pt_eg_you_are_a_luxury_concier(inputs)
	return ko_eg_you_are_a_luxury_concier(inputs)
});